export const getSingleFieldValue = (v) => {
    if (typeof v === 'string')
        return v;
    return v.length > 0 ? v[0] : '';
};
